
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-demo/vip-pass",
      function () {
        return require("private-next-pages/battle-demo/vip-pass.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-demo/vip-pass"])
      });
    }
  